import { render } from "./layout-block.vue?vue&type=template&id=51aa7536&scoped=true&ts=true"
import script from "./layout-block.vue?vue&type=script&lang=ts"
export * from "./layout-block.vue?vue&type=script&lang=ts"

import "./layout-block.vue?vue&type=style&index=0&id=51aa7536&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51aa7536"]])

export default __exports__